// custom typefaces
import "@fontsource-variable/noto-sans-jp"
import "@fontsource-variable/montserrat"
import "@fontsource/merriweather"
// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"

// ページ遷移時にスクロール位置を最上部へ確実にリセット
export const shouldUpdateScroll = ({ routerProps: { location } }) => {
  const { pathname } = location
  // アンカーリンク（#id）の場合はスクロール位置を維持
  if (location.hash) {
    return true
  }
  // それ以外は常に最上部へ
  window.scrollTo(0, 0)
  return [true, pathname]
}
